import { Link } from "react-router-dom";
import { useOrgan } from "../hooks/useOrgan";
import { organizationPrimaryColors } from "../layouts/PermanentSidebarMUI";
import { Button as MuiButton } from "@mui/material";

/**
 *
 * @param {Object} props
 * @param {string} props.text Texto do botão
 * @param {string} [props.link] Link para redirecionar
 * @param {function} [props.onClick] Função para ser executada ao clicar
 * @param {string} [props.type] Tipo do botão
 * @param {boolean} [props.disabled] Botão desabilitado
 * @param {string} [props.variant] Variant do botão
 * @param {string} [props.textTransform] Transformação do texto do botão
 * @param {React.ReactNode} [props.startIcon]
 * @param {React.ReactNode} [props.endIcon]
 * @param {Object} [props.sx] Classes do botão
 * @returns
 */
const Button = ({
  text,
  link,
  buttonPathState,
  onClick,
  type = "button",
  disabled = false,
  variant = "contained",
  textTransform = "capitalize",
  startIcon,
  endIcon,
  sx = {},
}) => {
  const { selectedOrgan } = useOrgan();
  const primaryColor = selectedOrgan?.name
    ? organizationPrimaryColors[selectedOrgan.name.toUpperCase()] ||
      organizationPrimaryColors.ALUCOM
    : organizationPrimaryColors.ALUCOM;

  const sxStyle = {
    fontWeight: "bold",
    textTransform,
    fontSize: "1rem",
    lineHeight: "1.5",
    padding: "8px 16px",
    margin: "0 .2rem",
    borderRadius: ".35rem",
    transition: "all .15s ease-in-out",
    ...(variant === "outlined" && {
      color: primaryColor,
      backgroundColor: "transparent",
      borderColor: primaryColor,
    }),
    ...(variant === "contained" && {
      color: "#FFFFFF",
      backgroundColor: primaryColor,
      borderColor: "transparent",
      "&:hover": {
        color: "#FFFFFF",
      },
    }),
    ...sx,
  };

  return link ? (
    <MuiButton
      component={Link}
      to={link}
      state={buttonPathState}
      variant={variant}
      type={type}
      onClick={onClick}
      sx={sxStyle}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}>
      {text}
    </MuiButton>
  ) : (
    <MuiButton
      variant={variant}
      type={type}
      onClick={onClick}
      sx={sxStyle}
      disabled={disabled}
      startIcon={startIcon}
      endIcon={endIcon}>
      {text}
    </MuiButton>
  );
};

export default Button;
